import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  IDP_APP,
  ReplaceItem,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { EndpointKey, MFA_OAUTH_URL } from '../../../../constants';
import {
  ILoginUserNamePasswordInput,
  LoginAuthWithCredentialsResponse,
  OauthAEMConfig,
  PostWithCredentials
} from '../../../../models';
import { UtilService } from '../../../util-service/util-service';

@Injectable({
  providedIn: 'root'
})
export class LoginPostWithCredService {
  loginAuthHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.checkUsernamePassword+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private utils: UtilService,
    private http: HttpClient,
    private appConfig: AppConfigService
  ) {}

  loginPostWithCredentials = (
    authConfig: OauthAEMConfig,
    flowIdValue: string,
    userInputFields: ILoginUserNamePasswordInput
  ): Observable<LoginAuthWithCredentialsResponse> => {
    let userNamePingFlow = '';

    if (userInputFields?.lastName) {
      userNamePingFlow = `${userInputFields.userName}${userInputFields?.lastName}`;
    } else {
      userNamePingFlow = userInputFields.userName;
    }

    const payload: PostWithCredentials = {
      username: userNamePingFlow,
      password: userInputFields.password
    };

    const getLoginPostWithCredentialsUrl = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const loginPostWithCredentialsUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: getLoginPostWithCredentialsUrl
      }
    ];

    return new ApiBuilder<
      PostWithCredentials,
      LoginAuthWithCredentialsResponse
    >(this.http, this.appConfig)
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(loginPostWithCredentialsUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.LOGIN_TIMEOUT ?? 10000)
      .payload(payload)
      .httpHeaders(this.loginAuthHeader)
      .errorHandler(this._errorHandler)
      .library('LOGIN_POST_WITH_CREDENTIALS_SERVICE')
      .withCredentials(true)
      .create();
  };
}
